<template>
  <b-modal
    hide-header
    :visible="showModal"
    @hidden="closeModal">
    <b-alert dismissible variant="danger" v-model="top_alert.visible">
      {{ this.top_alert.text}}
    </b-alert>
    <b-modal
      ok-only
      hide-footer
      title="File Format"
      ref="inner-modal">
      <b-row class="m-2">
        <p>
          Files must be in a plain text format (.txt and .csv are fine), where values are comma separated, and with each entry on its own new line.<br><br>
          Only two columns are necessary: "num" and "qty", case-insensitive. A header line, comma separated, with the name of each column in its respective position should be the first line of the file.<br>
          Additional columns will not have an effect.<br>
        </p>
      </b-row>
      <b-row class="m-1">
        <b-btn-group>
          <b-button v-b-toggle.example-collapse variant="warning">Example 1</b-button>
          <b-button v-b-toggle.example-collapse-two variant="warning">Example 2</b-button>
        </b-btn-group>
      </b-row>
        <b-collapse accordion="file-example" id="example-collapse">
          <b-card><i>
            qty,num<br>
            1,am-1319<br>
            2,am-1342<br>
            1,am-1312<br>
          </i></b-card>
        </b-collapse>
        <b-collapse accordion="file-example" id="example-collapse-two">
          <b-card><i>
            num,desc,qty<br>
            am-1312,a cool part that we sell,1<br>
            am-1342,this part is for first,3<br>
            am-1329,this part definitely isn't VEX,5<br>
          </i></b-card>
        </b-collapse>
    </b-modal>
    <b-row>
      <b-col>
        <b-form-file
         class="my-2"
         v-model="file"
         :state="Boolean(file)"
        ></b-form-file>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button-group>
          <b-button
            class="sm"
            variant="success"
            :disabled="this.file == null"
            @click="readFile"
          >Read File
          </b-button>
          <b-button
            variant="danger"
            :disabled="this.file == null"
            @click="clear"
          >Clear file
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="2" align-self="end">
        <b-button @click="$refs['inner-modal'].show()" v-b-popover.hover="'File format'" class="px-27" variant="warning">
          <span style="font-size:15px"><i class="fas fa-info"/></span>
        </b-button>
      </b-col>
    </b-row>
    <p class="mt-3" v-for="i in this.items"><strong>{{i.qty}}x</strong> <i>{{i.num}}</i><br></p>
    <template slot="modal-footer">
      <b-button variant="success" @click="addItems">Add Items to Order</b-button>
      <b-button variant="danger" @click="closeModal">Cancel</b-button>
    </template>
  </b-modal>
</template>

<script>


export default {
  name: 'list-upload',
  props: {
    show: false,
  },
  data() {
    return {
      file: null,
      showModal: false,
      items: [],
      top_alert: {
        visible: false,
        text: '',
      }
    }
  },
  computed: {

  },
  methods: {
    clear() {
      this.file = null;
      this.items = [];
    },
    readFile() {
      this.items = [];
      if (this.file == null) return -1;
      var reader = new FileReader();
      reader.readAsBinaryString(this.file);
      var items = this.items;
      var result = 0;
      reader.onloadend = function() {
        var lines = reader.result.split('\n');
        var template = lines[0].split(',').map( s => s.trim() );
        let numIndex = template.map((x) => {if (x != ''){return x.toLowerCase()}}).indexOf('num');
        let qtyIndex = template.map((x) => {if (x != ''){return x.toLowerCase()}}).indexOf('qty');
        console.log(lines, template, numIndex, qtyIndex);

        if (numIndex == -1 || qtyIndex == -1) {
          this.alertFormat('Please check that your file contains a first line with columns "qty" and "num"');
          result = -1;
          return;
        }


        let issues = ''
        for (let i in lines) {
          if (i == 0 || lines[i] == '') continue;
          let item = lines[i].split(',');
          let itemNum = item[numIndex];
          let itemQty = item[qtyIndex];
          if (itemNum == '' || itemQty == '') {
            let currLine = parseInt(i) + 1;
            if (issues == '') {
              issues += `${currLine}`;
            }
            else {
              issues += `, ${currLine}`;
            }
            this.alertFormat(`There was a formatting error on line(s): ${issues}`);
            continue;
          }
          items.push({num: item[numIndex], qty: item[qtyIndex]});
        }

      }.bind(this);

    },
    addItems() {
      this.$emit('addItems', this.items)
      this.closeModal();
      this.clear();
    },
    closeModal() {
      this.showModal = false;
      this.$emit('visibilityChange', this.showModal);
    },
    alertFormat( message ) {
      this.top_alert.visible = true;
      this.top_alert.text = message;
    },
  },
  watch: {
    showModal: function() {
      this.$emit('visibilityChange', this.showModal);
    },
    show: function() {
      this.top_alert.visible = false;
      this.showModal = this.show;
    },
    file: function() {
      this.items = [];
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/inventory-request/ListUpload.vue